window._theme = window._theme || {};
_theme.isMobile = $(window).width() < 768 ? true : false;
_theme.isIpad = $(window).width() < 1025 ? true : false;
_theme.isIpadAndUp = $(window).width() > 767 ? true : false;
_theme.isLaptopAndUp = $(window).width() > 1199.99 ? true : false;
 
_theme.showMobileMenu = function(){
  if($('.form-popup.toggle-slides [data-close-popup]')){
    $('.form-popup.toggle-slides [data-close-popup]').click();
  }
  $('.wrapper-overlay').addClass('active');
  $('html').addClass("translate-overlay");
  if($('html').hasClass('translate-overlay')){
    $('body').addClass('scroll-stop')
    setTimeout(function(){
      $('.mb-area-mob .close-mob-trig').focus()
  },1000)
  }
  var aria = $(".hamburger-icon .icon-nav").attr("aria-expanded");
  if (aria == "true") {
    $(".hamburger-icon .icon-nav").attr("aria-expanded", "false")
  } else {
    $(".hamburger-icon .icon-nav").attr("aria-expanded", "true");
  }
  $(".close-menu-mb").toggleClass("menu-open");
  $(".main-menu.jas-mb-style").css({ overflow: "" });
  $(".site-nav").find("[data-toggle-menu-mb]").parent().next(".sub-menu-mobile").removeClass("sub-menu-open");
  $('*').not($('.mb-area-mob').find('*')).not('.mb-area-mob').not($('.mb-area-mob').parents()).attr('aria-hidden','true');
  
  setTimeout(function () {
    _theme.focusTrap($('.mb-area-mob nav.nav-bar'), function () {
      $('.mb-area-mob button.close-mob-trig').click()
    }, null, { disableLinearNavigation: true });
  }, 250);
}

_theme.closeMobileMenu = function (getFocus, isCloseButton){
  $('.mb-area-mob .sub-menu-mobile').removeClass('sub-menu-open');
    $('html').removeClass("translate-overlay");
    $(".toolbar .column-left .sidebar-label span").attr("aria-expanded", "false");
    $(".close-menu-mb").removeClass("menu-open");
    $(".main-menu.jas-mb-style").css({ overflow: "" });
    $(".site-nav").find("[data-toggle-menu-mb]").parent().next(".sub-menu-mobile").removeClass("sub-menu-open");
    $('.wrapper-overlay').removeClass('active');
    $(".hamburger-icon .icon-nav").attr("aria-expanded", "false");
    $(".close-menu-mb").removeClass("menu-open");
    $('*').not($('.mb-area-mob').find('*')).not('.mb-area-mob').not($('.mb-area-mob').parents()).removeAttr('aria-hidden','true');
    _theme.toggleSideCart(false,true, !isCloseButton);
    if(getFocus){
      setTimeout(function () {
          $('.footer-pane-item.shopMenu').focus();
      }, 500);
    }
}

_theme.getOS = function() {
  if(!window.navigator) return '';
  var userAgent = window.navigator.userAgent;
  var userAgentData = window.navigator.userAgentData;
  var platform = userAgentData ? userAgentData.platform ? userAgentData.platform :  window.navigator.platform : window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'mac-os';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'ios';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'windows';
  } else if (/Android/.test(userAgent)) {
    os = 'android';
  } else if (/Linux/.test(platform)) {
    os = 'linux';
  }

  return os;
}

_theme.iPhoneVersion = function(){
  var iHeight = window.screen.height;
  var iWidth = window.screen.width;

  if (iWidth === 414 && iHeight === 896) {
    return "xmax-xr";
  } else if (iWidth === 375 && iHeight === 812) {
    return "x-xs";
  } else if (iWidth === 320 && iHeight === 480) {
    return "4";
  } else if (iWidth === 375 && iHeight === 667) {
    return "6";
  } else if (iWidth === 414 && iHeight === 736) {
    return "6-plus";
  } else if (iWidth === 320 && iHeight === 568) {
    return "5";
  } else if (iHeight <= 480) {
    return "2-3";
  }
  return 'none';
}

_theme.focusTrap = function(elem, cb, tabbableAdditionalElems, settings){
  const trapSettings = settings || {};
  let tabbableElems = ['select', 'input', 'textarea', 'button', 'a'];
  if(tabbableAdditionalElems){
    if(Array.isArray(tabbableAdditionalElems)) tabbableElems = tabbableElems.concat(tabbableAdditionalElems)
    if(typeof tabbableAdditionalElems === 'string') tabbableElems.push(tabbableAdditionalElems);
  }
  let tabbable = elem.find(tabbableElems.join(',')).filter(':visible');
  let firstTabbable = tabbable.first();
  let lastTabbable = tabbable.last();
  firstTabbable.focus();
  lastTabbable.off('keydown').on('keydown', function(e) {
    if(trapSettings.disableLinearNavigation && e.key){
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        return;
      }
    }

    if ((e.which === 9 && !e.shiftKey)) {
        e.preventDefault();
        firstTabbable.focus();
    }
  });

  firstTabbable.off('keydown').on('keydown', function(e) {
    if(trapSettings.checkSameElements && e.key){
      if(firstTabbable.get(0) == lastTabbable.get(0)){
        e.preventDefault();
        return;
      }

    }

    if(trapSettings.disableLinearNavigation && e.key){
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        return;
      }
    }

    if (e.which === 9 && e.shiftKey && !trapSettings.enableBackwardJourney) {
      e.preventDefault();
      lastTabbable.focus();
    }
  });
    
  elem.off('keydown').on('keydown', function(e) {
    if(trapSettings.disableLinearNavigation && e.key){
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        return;
      }
    }

    if (e.keyCode === 27 ) {
      cb(elem,e);
    }
  });
}

_theme.focusMove=function(elem) {
  let tabbable = elem.find('select, input, textarea, button, a').filter(':visible');
  let firstTabbable = tabbable.first();

  firstTabbable.focus();
}

_theme.focusFirstTabbable = function($container, tabbableAdditionalElems){
  if(!$container || $container.length === 0) return;
  try {
    const tabbableElems = ['select', 'input', 'textarea', 'button', 'a'];
    if(tabbableAdditionalElems){
      if(Array.isArray(tabbableAdditionalElems)) tabbableElems = tabbableElems.concat(tabbableAdditionalElems)
      if(typeof tabbableAdditionalElems === 'string') tabbableElems.push(tabbableAdditionalElems);
    }
    const tabbable = $container.find(tabbableElems.join(',')).filter(':visible');
    tabbable.first().focus();
  } catch(err){
  }
}

_theme.refreshKlarna = function(){
  if(window.Klarna && Klarna.OnsiteMessaging) Klarna.OnsiteMessaging.refresh();
}

_theme.toggleLoading = function (show) {
  if (show) {
    $('.loading-modal').removeClass('hidden');
  } else {
    $('.loading-modal').addClass('hidden');
  }
}

_theme.initSmartWishlist = function(){
  if(window.SmartWishlistMain) window.SmartWishlistMain();
}
 
_theme.toggleWrapperOverlay = function(show){
  if(show){
    $('.wrapper-overlay').addClass('active');
  } else {
    $('.wrapper-overlay').removeClass('active');
  }
}

_theme.toggleLoginModal = function(show){
  if(show){
    $('.new-popup-wrapper.account-login').fadeIn();
    _theme.toggleWrapperOverlay(1);
  } else {
    $('.new-popup-wrapper.account-login').fadeOut();
    _theme.toggleWrapperOverlay();
  }
}

_theme.toggleSideCart = function (show,stopFocus, isAutoAction) {
  if (show) {
    $('html').addClass('cart-show');
    $('.wrapper-overlay').addClass('active');
    if($('#dropdown-cart .products-grid.new-products-grid').hasClass('slick-initialized')){
      $('#dropdown-cart .products-grid.new-products-grid').slick('refresh');
    }
    if($('.empty-cart-coll-slider').hasClass('slick-initialized')){
      $('.empty-cart-coll-slider').slick('refresh');
    }

    // track action: Datalayer
    _theme.track.trackEvent('minicart_opened', isAutoAction ? 'add to cart click' : 'cart icon click');
  } else {
    const cartOfferList = document.querySelector('cart-offer-list');
    $('html').removeClass('cart-show');
    $('.wrapper-overlay').removeClass('active');
    if(!stopFocus) $('[data-cart-toggle]').focus();
    _theme.toggleSideCartQv();
    if(cartOfferList && cartOfferList.hide) cartOfferList.hide();

    // track action: Datalayer
    _theme.track.trackEvent('minicart_closed', isAutoAction ? 'outside click' : 'cross icon click');
  }
}

_theme.toggleSideCartQv = function (show) {
  if (show) {
    $('.wrapper-overlay').addClass('active');
    $('.sidecart-qv').addClass('active');
    $('.sidecart-qv').siblings().attr('aria-hidden','true')
  } else {
    $('.sidecart-qv').removeClass('active');
    $('.sidecart-qv').siblings().removeAttr('aria-hidden')
  }
}

_theme.checkQuickViewRating = function (delay) {
  setTimeout(function () {
    $(".product-rating").each(function () {
      let _this = $(this);
      if (_this.find(".bv_numReviews_text").length > 0) {
        if (_this.find(".bv_avgRating_component_container").length > 0) {
          _this.removeClass('display-rating');
        } else {
          _this.addClass('display-rating')
        }
      }
    });
  }, delay || 1000);
}

_theme.handleKeyboardUpDownButtonPress = function(evt){
  const key = evt.key.toUpperCase();
  if(key === 'ARROWUP'){
    const $prevElem = $(this).prev();
    if($prevElem.length) {
      $prevElem.addClass('selected').siblings().removeClass('selected');
      setTimeout(function(){
        $prevElem.focus();
      }, 250);
    }
  }

  if(key === 'ARROWDOWN'){
    const $nextElem = $(this).next();
    if($nextElem.length) {
      $nextElem.addClass('selected').siblings().removeClass('selected');
      setTimeout(function(){
        $nextElem.focus();
      }, 250);
    }
  }

  if(key === 'TAB' && !evt.shiftKey){
    const $nextElem = $(this).next();
    if($nextElem.length === 0) evt.preventDefault();
  }

  if(key === 'ENTER' || (key === ' ' && evt.which === 32)){
    evt.target.click();
  }

  if(key === 'ESCAPE'){
    if(this.parentElement.classList.contains('active')) this.parentElement.classList.remove('active');
    if(this.parentElement.style.display === 'block') this.parentElement.style.display = 'none';
    let tabbableElems = ['select', 'input', 'textarea', 'button', 'a', '[tabindex="0"]', '[role="button"]'];
    let mainParent = this.parentElement;
    if(['UL', 'OL'].indexOf(this.parentElement.tagName) > -1) mainParent = mainParent.parentElement;
    const nextTabbableElem =  mainParent.querySelector(tabbableElems.join(','));
    if(nextTabbableElem && nextTabbableElem.getBoundingClientRect().height !== 0) nextTabbableElem.focus();
  }
}

_theme.handleKeyboardEnterOrSpacePress = function(evt){
  const key = evt.key.toUpperCase();
  if(key === 'TAB'){ return; }

  evt.preventDefault()
  if(key === 'ENTER' || (key === ' ' && evt.which === 32)){
    this.click();
  }
}

_theme.showLoginForm = function(){
  setTimeout(function(){
    $('[data-close-popup]').focus()
  },500)
  setTimeout(function(){
    $('*').not($('.form-popup.toggle-slides').find('*')).not('.form-popup.toggle-slides').not($('.form-popup.toggle-slides').parents()).attr('aria-hidden','true');
  },500)   
  $('.form-popup.toggle-slides').css('display','block');
  $('html').addClass('logPop')
  $('.wrapper-overlay').addClass('active');
  $('.form-popup.toggle-slides').removeClass('hiddenForm');
  _theme.closeMobileMenu(false)
  $('.wrapper-overlay').addClass('active');
}

_theme.hideLoginForm = function(stopFocus){
  $('.form-popup').css('display','none');
  $('.wrapper-overlay').removeClass('active');
  $('html').removeClass('logPop')
  $('*').not($('.form-popup.toggle-slides').find('*')).not('.form-popup.toggle-slides').not($('.form-popup.toggle-slides').parents()).removeAttr('aria-hidden','true');
  
  if(stopFocus) return;

  setTimeout(function(){
    $('[data-show-popup]').focus()
  },500)
}

_theme.toggleOverlay = function(show){
  if(show){
    $('.wrapper-overlay').addClass('active');
  } else {
    $('.wrapper-overlay').removeClass('active');
  }
}

_theme.Helpers = (function () {
  function setParamInURL(param, value, _url) {
    if (!_url) _url = window.location.href;
    var url = new URL(_url);
    var search_params = url.searchParams;
    search_params.set(param, value);
    url.search = search_params.toString();
    var new_url = url.toString();

    return new_url;
  }
  
  function getParamFromURL(param, _url) {
    if (!_url) _url = window.location.href;

    var url = new URL(_url);
    var search_params = url.searchParams;
    var paramVal = search_params.get(param);

    return paramVal;
  }

  function deleteParamFromURL(param, _url) {
    if (!param) return null;
    if (!_url) _url = window.location.href;
    var url = new URL(_url);
    var search_params = url.searchParams;
    search_params.delete(param);
    var new_url = url.toString();
    return new_url;
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  async function changeLineItemQty(line, qty, viaId, successCB, errorCB) {
    let cartItemChangeError = document.querySelectorAll('.cartItemChangeError')
    let data = {"quantity": qty, "line": line};
    if (viaId) {
      data = { "quantity": qty, "id": `${line}` };
    }

    try {
      const resp = await fetch('/cart/change.js', {
        method: "post",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(data)
      });
      const cart = await resp.json();
      if (successCB && typeof successCB === 'function') successCB(cart);
    } catch (error) {
      _theme.toggleLoading()
        cartItemChangeError[line - 1].classList.remove('hidden');
        setTimeout(()=>{
          cartItemChangeError[line - 1].classList.add('hidden');
        },3000);
        
      _theme.toggleAjaxModal(1, error.message);
      if (errorCB && typeof errorCB === 'function') errorCB(err);

      let currentLineItem = $('#dropdown-cart .mini-products-list [line-index="'+ line +'"]');
      if(currentLineItem.length > 0) {
        let input = currentLineItem.find(".quantity-box input");
        let plus = currentLineItem.find(".quantity-box .plus");
        input.val(qty-1);
        plus.addClass('disabled');
      }
    }
  }
  
  function handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }

  function goToPreviousPage(){
    window.history.back();
  }

  function setItemIntoLS(key, value) {
    if (typeof localStorage === undefined || typeof localStorage === null) return;
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
    return true;
  }

  function getItemFromLS(key) {
    if (typeof localStorage === undefined || typeof localStorage === null) return;
    let value = localStorage.getItem(key);
    return JSON.parse(value);
  }

  function removeItemFromLS(key) {
    if (typeof localStorage === undefined || typeof localStorage === null) return;
    localStorage.removeItem(key);
    return true;
  }

  function setItemIntoSS(key, value){
    if(typeof sessionStorage === undefined || typeof sessionStorage === null) return;
    if(typeof value !== 'string'){
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
    return true;
  }

  function getItemFromSS(key){
    if(typeof sessionStorage === undefined || typeof sessionStorage === null) return;
    let value = sessionStorage.getItem(key);
    return JSON.parse(value);
  }

  function removeItemFromSS(key){
    if(typeof sessionStorage === undefined || typeof sessionStorage === null) return;
    sessionStorage.removeItem(key);
    return true;
  }

  function updateHtml(html, str, data){
    var newhtml = html;
    if(newhtml.indexOf(str) > -1){
      newhtml = newhtml.replace(str, data);
      return this.updateHtml(newhtml, str, data);
    } else {
      return newhtml;
    }
  }

  function addItem(vid, qty, callback, runCBAfterOpen){
    window.Shopify.addItem(vid, qty, function(res){
      Shopify.getCart(function(cart){
          if(!runCBAfterOpen && callback && typeof callback === 'function'){
            callback(cart);
          } else {
            _theme.MiniCart.lineItemChangeCallBack(cart, function(){
              _theme.toggleSideCart(1, null, true);
              if(callback && typeof callback === 'function') callback(cart);
            });
          }
      });
    });
  }

  function addProductToCart(vid, qty, props, successCB, errorCB){
    if(!vid) return;

    let properties = null;
    if(props && typeof props === 'string') properties = {_proType: props};
    if(props && typeof props === 'object') properties = props;

    jQuery.ajax({
      url: window.routes.cart_add_url + '.js',
      method: 'POST',
      beforeSend: function() {
        _theme.toggleLoading(1);
      },
      data: {
        quantity: qty,
        id: vid,
        properties: properties
      },
      dataType: 'json',
      success:function(res){
        if(successCB && typeof successCB === 'function') successCB(res);
      },
      error: function(err){
        _theme.toggleAjaxModal(1, jQuery.parseJSON(err.responseText).description);
        if(errorCB && typeof errorCB === 'function') errorCB(err);
      },
      complete: function(){
        _theme.toggleLoading();
      }
    });
  }

  function validateEmail(email){
    if(!email) email = '';
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    return email.match(regex);
  }

  const throttle = (fn, ms = 300) => {
    let lastCall = Date.now() - 2 * ms
    let result
    let trailing

    function invoke(...args) {
        lastCall = Date.now()
        return (result = fn.apply(this, args))
    }

    return function throttler(...args) {
        const now = Date.now()

        if (now - lastCall >= ms) {
            return invoke.apply(this, args)
        }

        clearTimeout(trailing)
        trailing = setTimeout(() => invoke.apply(this, args), lastCall - now + ms)

        return result
    }
  }

  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  function formatPrice(amount){
    return  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount || 0)
  }

  return {
    setParamInURL: setParamInURL,
    getParamFromURL: getParamFromURL,
    deleteParamFromURL: deleteParamFromURL,
    getCookie: getCookie,
    changeLineItemQty: changeLineItemQty,
    handleize: handleize,
    setItemIntoLS: setItemIntoLS,
    getItemFromLS: getItemFromLS,
    removeItemFromLS: removeItemFromLS,
    setItemIntoSS: setItemIntoSS,
    getItemFromSS: getItemFromSS,
    removeItemFromSS: removeItemFromSS,
    updateHtml: updateHtml,
    addItem: addItem,
    addProductToCart: addProductToCart,
    validateEmail: validateEmail,
    goToPreviousPage: goToPreviousPage,
    throttle: throttle,
    insertAfter: insertAfter,
    formatPrice: formatPrice
  }
})();

function showRecoverPasswordForm() {
  $('#modal-title').text('Forgot Password');
  $('#recover_password').show();
  $('#customer_login,.customer_login_wrap-1').hide();
  _theme.focusTrap($('#log-in-form'),function() {
    $('.cm-log-in-form .close-modal').trigger('click');
  });  
  setTimeout(function(){
    $('#recover-email').focus();
  },250)
}

function hideRecoverPasswordForm() {
  $('#recover_password').hide();
  $('#customer_login,.customer_login_wrap-1').show();
  $('.cm-for-pass').focus();
  
}

// Allow deep linking to the recover password form
if (window.location.hash == '#recover') {
  showRecoverPasswordForm()
}

$(document).ready(function(){
  if($('.form-popup').length){
    $('.form-popup').css('display','none');
  }

  $('[data-close-popup]').on('click', function(){
    _theme.hideLoginForm();
  });
  $('[data-show-popup]').on('click', function(){
    _theme.showLoginForm();
  });
  
  $('.dflexspbtw').on('click', function(e) {
    $(this).next('p').toggleClass("show");
    $(this).toggleClass("show1");
    if($(this).hasClass('show1')){
      $(this).attr('aria-expanded', true);
    } else {
      $(this).attr('aria-expanded', false);
    }
    e.preventDefault();
});


  
  $('.wrapper-overlay').click(function(){
    $('.form-popup').hide();
    $('body').removeClass('remove-scroll')
    // $('*').not($('.form-popup.toggle-slides').find('*')).not('.form-popup.toggle-slides').not($('.form-popup.toggle-slides').parents()).removeAttr('aria-hidden','true');
})

$('.num').keyup(function () { 
  this.value = this.value.replace(/[^0-9]/g,'');
});

  // above code for popup
$('#accordion-toggle').on('click',function(){
  $('.wrapper-overlay').toggleClass('active');
    $('body').toggleClass('remove-scroll')
  // console.log("check")
  $(".toggle-slides").toggle();
  // console.log("check dwon")

  _theme.focusTrap($('.form-popup.toggle-slides'),function() {
    $('.form-popup.toggle-slides').css('display','none');
    $('.wrapper-overlay').removeClass('active');
    $('#accordion-toggle a').focus();
  });


})
// $(".footer-pane-item").on('click',function(){
//   // $('.wrapper-overlay').toggleClass('active');
//    $(".toggle-slides").toggle();

// })
// console.log(document.querySelector("[data-title='account']"),"fooooooooooooooooooooooooo"); 
$('.openBtn2').on('click',function(){
  $('#modal-title').text('Register');  
  $('.form-popup.toggle-slides').css('display','none');
  $('.wrapper-overlay').addClass('active');
  $('.cm-log-in-form').show().removeClass('fade');
  $('.cm-log-in-form .cm-log-in-right-col').addClass('showForm');
  $('.cm-log-in-form .modal-dialog').addClass('showForm');
  $('.cm-login-w-wrap').hide();
  $('.cm-registerform-wrap').show();
  $('*').not($('.form-popup.toggle-slides').find('*')).not('.form-popup.toggle-slides').not($('.form-popup.toggle-slides').parents()).removeAttr('aria-hidden','true');
  $('*').not($('#log-in-form').find('*')).not('#log-in-form').not($('#log-in-form').parents()).attr('aria-hidden','true');
  _theme.focusTrap($('#log-in-form'),function() {
    $('.cm-log-in-form .close-modal').trigger('click');
  });
})


$('.cm-log-in-form .close-modal').on('click',function(){
  $('*').not($('.form-popup.toggle-slides').find('*')).not('.form-popup.toggle-slides').not($('.form-popup.toggle-slides').parents()).removeAttr('aria-hidden','true');
  $('*').not($('#log-in-form').find('*')).not('#log-in-form').not($('#log-in-form').parents()).removeAttr('aria-hidden','true');
  $('.wrapper-overlay').removeClass('active');
  $('cart-offer-list').attr('aria-hidden','true');
  $('.cm-log-in-form').hide().addClass('fade');
  $('.cm-log-in-form .modal-dialog').removeClass('showForm');
  $('#accordion-toggle a').focus();
  $('body').removeClass('remove-scroll')
  $('html').removeClass('logPop')
  
})

$('.openBtn').on('click',function(e){
  $('*').not($('.form-popup.toggle-slides').find('*')).not('.form-popup.toggle-slides').not($('.form-popup.toggle-slides').parents()).removeAttr('aria-hidden','true');
  $('*').not($('#log-in-form').find('*')).not('#log-in-form').not($('#log-in-form').parents()).attr('aria-hidden','true');
  $('#modal-title').text('Account Sign In');
  $('.form-popup.toggle-slides').css('display','none');
  $('.wrapper-overlay').addClass('active');
  $('.cm-log-in-form').show().removeClass('fade');
  $('.cm-log-in-form .modal-dialog').addClass('showForm');
  $('.cm-login-w-wrap').show();
  $('.cm-registerform-wrap').hide();

  _theme.focusTrap($('#log-in-form'),function() {
    $('.cm-log-in-form .close-modal').trigger('click');
  });
})


$('.login-now-btn-wrapper').on('click',function(){

  $('.cm-login-w-wrap').show();
  $('.cm-registerform-wrap').hide();
  _theme.focusTrap($('#log-in-form'),function() {
    $('.cm-log-in-form .close-modal').trigger('click');
  });

})
$('.register-now-btn-wrapper').on('click',function(){
  $('#modal-title').text('Register');
  $('.cm-login-w-wrap').hide();
  $('.cm-registerform-wrap').show();
  _theme.focusTrap($('#log-in-form'),function() {
    $('.cm-log-in-form .close-modal').trigger('click');
  });
  setTimeout(function(){
    $('#first_name').focus()
  },250)
})

$('.showRecoverPasswordForm').on('click',function(){

  $('.col-left-1 form').hide();
  $('#recover_password').show();
  setTimeout(function() {
    $('#recover-email_login_page').focus();
  })                                                                                                 
})
$('.cancel_text.hideRecoverPasswordForm').on('click',function(){
  $('#modal-title').text('Account Sign In');
  $('.col-left-1 form').show();
  $('#recover_password').hide();
  $(this).closest('.col-left').find('form[action="/account/login"] input[type="email"]').focus();
})

// confirm password validation        
let password = document.getElementById("create_password")
let confirm_password = document.querySelector("#create_customer #password_confirmation");

function validatePassword(){
  if(password.value != confirm_password.value) {
    confirm_password.setCustomValidity("Passwords Do not Match");
  } else {
    confirm_password.setCustomValidity('');
  }
}
password.onchange = validatePassword;
confirm_password.onkeyup = validatePassword;
});